import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';
import EllipsisStyle from '@sdk/components/ui/EllipsisStyle';

export const MapColumnsContainer = styled.div<{ cols: string[] }>`
  background: ${({ theme }) => theme.colors.columnHeaders};
  padding: 20px 20px 0;
  margin: 0 -20px;
  display: grid;
  grid-template-columns: 18px ${({ cols }) => cols.map(() => '1fr').join(' ')};
  gap: 0 20px;
  justify-items: center;
  align-items: center;
  overflow-x: auto;
  max-height: 500px;
`;

export const CheckboxLabel = styled(Text14)`
  color: ${({ theme }): string => theme.colors.gray};
  padding-left: 5px;
  cursor: pointer;
`;

export const FormField = styled.div`
  margin-left: auto;
  width: 205px;
`;

export const MapColumnsCell = styled.div<{ withBorder?: boolean; inactive?: boolean }>`
  width: 100%;
  min-width: 100px;
  position: relative;
  opacity: ${({ inactive }) => (inactive ? 0.65 : 1)};

  ${({ withBorder, theme }) =>
    withBorder
      ? `
    &:after {
      content: '';
      border-bottom: 1px solid ${theme.colors.separatorOnGray};
      position: absolute;
      bottom: 0;
      left: -40px;
      right: 0;
    }
  `
      : ''}
`;

export const MapColumnsCellText = styled(Text14)`
  ${EllipsisStyle}
  width: 100%;
  display: inline-block;
  padding: 14px 0 10px;
`;
